export const URL = 'http://localhost:3000';

export const BASE_URL = 'https://api.splitfast.com/api'; //PRODUCTION
// export const BASE_URL = 'https://localhost:7047/api';   // DEVELOPMENT - Use for testing against local API Server

export const UserPermissionLevel = Object.freeze({
  None: 0,
  Guest: 1,
  Member: 2,
  Official: 3,
  Admin: 4,
  Owner: 5,
});

export const ONBOARDING = {
  OWNER: [
    {
      id: 1,
      title: 'Main platform feature #1',
      description:
        'Description of the main platform feature. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas maximus mauris diam.',
    },
    {
      id: 2,
      title: 'Main platform feature #2',
      description:
        'Description of the main platform feature. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas maximus mauris diam.',
    },
    {
      id: 3,
      title: 'Main platform feature #3',
      description:
        'Description of the main platform feature. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas maximus mauris diam.',
    },
  ],
};
